// INFO: CSS selector of the scroll area within the sidebar.
// Moved to standalone file to avoid redunant imports during build process
export const SCROLLBAR_CONTAINER = '.scrollbar-view';